import herald_align_full_fix from '../functions/herald_align_full_fix';
import clear_blur from "./clear_blur";

export default function () {
    clear_blur();
    if ($('#back-top').length) {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 400) {
                $('#back-top').fadeIn();
            } else {
                $('#back-top').fadeOut();
            }
        });
        $('body').on('click', '#back-top', function () {
            $('body,html').animate({
                scrollTop: 0
            }, 800);
            return false;
        });
    }
    $(window).resize(function () {
        $('.herald-clear-blur').clearBlur();
        herald_align_full_fix();
    });
}
